import { z } from 'zod';
/**
 * Ein Zeitpunkt, der sowohl im Speicher als auch über die Leitung gilt.
 *
 * Dieselben Schemas beschreiben zwei Zustände desselben Werts: Auf dem Server
 * liefert Drizzle ein `Date`, über JSON kommt eine Zeichenkette an — JSON kennt
 * keinen Datumstyp. Ein bloßes `z.date()` beschreibt nur den ersten Zustand.
 *
 * Solange nur der Server prüfte, fiel das nicht auf: Dort war der Wert immer schon
 * ein `Date`. Erst als die Oberfläche anfing, Antworten gegen dieselben Schemas zu
 * prüfen, wurde sichtbar, dass jede Antwort abgelehnt worden wäre — jeder
 * Zeitstempel darin ist eine Zeichenkette.
 *
 * `z.coerce.date()` nimmt beides an und liefert immer ein `Date`. Damit gilt das
 * Schema in beide Richtungen, und die Oberfläche bekommt Zeitstempel, mit denen
 * sie rechnen kann, statt Zeichenketten, die nur so aussehen.
 *
 * Ausdrücklich **nicht** für Eingaben: Ein Feld, das der Nutzer ausfüllt, ist ein
 * Handelstag und gehört zu `isoDateSchema`. Hier geht es allein um Zeitstempel,
 * die der Server setzt.
 */
export const timestampSchema = z.coerce.date();
//# sourceMappingURL=timestamp.js.map